/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Banners Module
define('modules/Banners/BannersTracking',[
    'jquery',
    'global/all',
    'global/GoogleAnalytics'
], function ($, Roc, GoogleAnalytics) {
    'use strict';

    function getItemData(element, attr) {
        return $(element).parents('.bannerImage').attr('data-' + attr);
    }

    // init banner click
    function bannerClick() {
        Roc.UI.siteBody.on('click', '[data-roc-action="bannerClick"]', function (e) {
            var bannerData = $(this).closest('[data-roc-action="banner"]').data('rocParams');
            var data = {
                'id': bannerData.bannerId,
                'name': bannerData.bannerName
            };

            doBannerClick(data);
        });
    };

    // init banner impression
    function bannerImpression() {
        $(document).ready(function () {
            var selector = document.querySelectorAll('[data-roc-action="banner"]');

            if (typeof selector !== typeof undefined && selector !== false) {
                $(selector).each(function () {
                    var bannerData = $(this).data('rocParams');
                    var data = {
                        'id': bannerData.bannerId,
                        'name': bannerData.bannerName
                    };

                    doBannerImpression(data);
                });
            }
        });
    }

    bannerClick();
    bannerImpression();

    function doBannerClick(data) {
        GoogleAnalytics.setBannerClick(data);
    }

    function doBannerImpression(data) {
        GoogleAnalytics.setBannerImpression(data);
    }

    var BannersTracking = {
        doBannerClick: doBannerClick,
        doBannerImpression: doBannerImpression
    };

    Roc.Logger.debug('BannerTracking.js Loaded:', BannersTracking);
    return BannersTracking;
});

